import React from 'react';
import { OtlIntro } from './otl/OtlIntro';
import { OtlParamoExample } from './otl/OtlParamoExample';
import { OtlEnvironmental } from './otl/OtlEnvironmental';
import { OtlList } from './otl/OtlList';
import { OtlVisor } from './otl/OtlVisor';
import { OtlVideo } from './otl/OtlVideo';
export function MapVisor() {
  return <section id="resultados" className="py-24 md:py-32 px-4 md:px-8 scroll-mt-24" data-id="element-228">
      <div className="max-w-[1400px] mx-auto" data-id="element-229">
        <OtlIntro data-id="element-230" />
        <OtlParamoExample data-id="element-231" />
        <OtlEnvironmental data-id="element-232" />
        <OtlList data-id="element-233" />
        <OtlVisor data-id="element-234" />
        <OtlVideo data-id="element-235" />
      </div>
    </section>;
}